import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MODES from './onSubmitModes';

const EditableWrapper = function (EditComponent, ViewComponent) {
    return class extends Component {
        static propTypes = {
            onUpdate: PropTypes.func.isRequired,
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        };

        state = {
            mode: MODES.VIEW,
            errorMsg: undefined,
        };

        onEdit(evt) {
            evt.preventDefault();
            this.setState({ mode: MODES.EDIT });
        }

        onCancel(evt) {
            evt.preventDefault();
            this.cancel();
        }

        cancel() {
            this.setState({
                mode: MODES.VIEW,
                errorMsg: undefined,
            });
        }

        serverError() {
            this.setState({ mode: MODES.EDIT });
        }

        error(msg) {
            this.setState({ errorMsg: msg });
        }

        onSave(model) {
            this.setState({ mode: MODES.SAVING });
            this.props
                .onUpdate(this.props.id, {
                    name: this.props.name,
                    value: model[this.props.name].trim(),
                })
                .then(this.cancel.bind(this))
                .catch(this.serverError.bind(this));
        }

        renderEditComponent() {
            return (
                <EditComponent
                    errorMessage={this.state.errorMsg}
                    mode={this.state.mode}
                    onCancel={this.onCancel.bind(this)}
                    onSave={this.onSave.bind(this)}
                    {...this.props}
                />
            );
        }

        renderViewComponent() {
            return (
                <ViewComponent
                    onEdit={this.onEdit.bind(this)}
                    {...this.props}
                />
            );
        }

        render() {
            switch (this.state.mode) {
                case MODES.EDIT:
                case MODES.SAVING:
                    return this.renderEditComponent();
                case MODES.VIEW:
                default:
                    return this.renderViewComponent();
            }
        }
    };
};

export default EditableWrapper;
